export const err = (obj: unknown) => {
  if (obj === null || obj === undefined) throw new Error('Required');
};

export const nonnull = <T>(candidate: T): T & {} => {
  if (candidate === null || candidate === undefined) {
    throw new Error('Required');
  }
  return candidate;
};
